import React from 'react'
import PropTypes from 'prop-types'
import Carousel from 'nuka-carousel'

import Icon from 'Pods/Shared/Icon/Icon'
import { CurrentBreakpoint } from 'Utils/GetBreakpoint'

import NewsFeedArticle from './NewsFeedArticle'

class NewsFeed extends React.Component {
  constructor() {
    super()

    this.state = {
      heightMode: 'current',
      modelsPerRow: 4,
      isShowingControls: true,
    }

    this.updateCarousel = this.updateCarousel.bind(this)
  }

  componentDidMount() {
    this.updateCarousel()
    window.addEventListener('resize', this.updateCarousel)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateCarousel)
  }

  updateCarousel() {
    let models = 4
    let controls = true

    switch (CurrentBreakpoint()) {
      case 'xs':
        models = 1.25
        controls = false
        break;
      case 'sm':
        models = 2.25
        controls = false
        break;
      case 'md':
        models = 3
        controls = true
        break;
      case 'lg':
        models = 3
        controls = true
        break;
      default:
        models = 4
        controls = true
    }

    this.setState({
      modelsPerRow: models,
      isShowingControls: controls,
      heightMode: 'max',
    })
  }

  render() {
    const doubleNewsArray = this.props.news.concat(this.props.news)
    const newsToShow = this.props.news.length < 6 ? doubleNewsArray : this.props.news

    return (
      <Carousel
        cellSpacing={20}
        wrapAround
        speed={500}
        cellAlign="left"
        transitionMode="scroll"
        heightMode={this.state.heightMode}
        slideIndex={0}
        slidesToShow={this.state.modelsPerRow}
        slidesToScroll={1}
        autoplay
        autoplayInterval={6000}
        withoutControls={!this.state.isShowingControls}
        renderCenterLeftControls={({ previousSlide }) => (
          <button
            className="btn btn-outline-default btn-white"
            onClick={previousSlide}
          >
            <Icon type={['fal', 'chevron-left']} notSpaced />
          </button>
        )}
        renderCenterRightControls={({ nextSlide }) => (
          <button
            className="btn btn-outline-default btn-white"
            onClick={nextSlide}
          >
            <Icon type={['fal', 'chevron-right']} notSpaced />
          </button>
        )}
      >
        {newsToShow.map((article) => (
          <NewsFeedArticle
            key={article.id}
            title={article.attributes.title}
            summary={article.attributes.summary}
            url={article.attributes.url}
            image={article.attributes.image.large}
            createdAt={article.attributes.createdAt}
          />
        ))}
      </Carousel>
    )
  }
}

NewsFeed.propTypes = {
  news: PropTypes.array.isRequired,
}

export default NewsFeed
